import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import Layout from './components/layout/Layout';

// Marketing Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';

// Shop Pages
import { ShopPage, ProductPage, CartPage, CheckoutPage, OrderSuccessPage } from './modules/shop/pages';

// Admin panel — lazy, u zasebnom chunk-u: kupci nikad ne skidaju ovaj kod.
const AdminApp = lazy(() => import('./modules/admin/AdminApp'));

import './index.css';

/** Javni sajt: zajednički header/footer kroz `Layout`. */
const PublicRoutes = () => (
  <Layout>
    <Routes>
      {/* Marketing Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/o-nama" element={<AboutPage />} />
      <Route path="/proizvodi" element={<ProductsPage />} />
      <Route path="/projekti" element={<GalleryPage />} />
      <Route path="/galerija" element={<Navigate to="/projekti" replace />} />
      <Route path="/kontakt" element={<ContactPage />} />
      <Route path="/saradjujte" element={<Navigate to="/kontakt" replace />} />

      {/* Shop Routes */}
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/shop/:category" element={<ShopPage />} />
      <Route path="/proizvod/:slug" element={<ProductPage />} />
      <Route path="/korpa" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/porudzbina/:orderNumber" element={<OrderSuccessPage />} />

      {/* 404 - Redirect to home */}
      <Route path="*" element={<HomePage />} />
    </Routes>
  </Layout>
);

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            {/* Admin ide van javnog Layout-a — bez header-a, footer-a i korpe. */}
            <Route
              path="/admin/*"
              element={
                <Suspense fallback={<div className="min-h-screen bg-neutral-50" />}>
                  <AdminApp />
                </Suspense>
              }
            />
            <Route path="*" element={<PublicRoutes />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
